// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".d2p-dict-checkbox{width:100%}.d2p-dict-checkbox.el-checkbox-group{line-height:40px}", ""]);
// Exports
module.exports = exports;
